export var SET_LANG = 'SET_LANG';
export var setLang = function (lang) { return ({
    type: SET_LANG,
    lang: lang,
}); };
//# sourceMappingURL=setting.js.map